// // import React, { useEffect, useState } from "react";
// // import PageSliderBar from "../Components/PageSliderBar/PageSliderBar";
// // import axios from "axios";
// // import { API_BASE_URL } from "../Config";
// // import AdvertisementCard from "../Components/AdvertisementCard";

// // const HowToMakeVariation = () => {
// //   const [variations, setVariations] = useState({});
// //   const [sideData, setSideData] = useState([]);

// //   useEffect(() => {
// //     const fetchVariationNames = async () => {
// //       try {
// //         const res = await axios.get(`${API_BASE_URL}/makevariations/names`);

// //         const list = res.data.data || [];
// //         const sidebar = res.data.sideData || [];

// //         const grouped = {};

// //         list.forEach((item) => {
// //           const type = item.variationType?.[0] || "Other";
// //           if (!grouped[type]) grouped[type] = [];
// //           if (item.asanaType) grouped[type].push(item);
// //         });

// //         setVariations(grouped);
// //         setSideData(sidebar);
// //       } catch (error) {
// //         console.error("API Fetch Error", error);
// //       }
// //     };

// //     fetchVariationNames();
// //   }, []);

// //   return (
// //     <div style={{ display: "flex" }}>
// //       <PageSliderBar
// //         title="How to make variation"
// //         data={variations}
// //         sideData={sideData}
// //       />
// //       <AdvertisementCard />
// //     </div>
// //   );
// // };

// // export default HowToMakeVariation;

// import React, { useEffect, useState } from "react";
// import PageSliderBar from "../Components/PageSliderBar/PageSliderBar";
// import axios from "axios";
// import { API_BASE_URL } from "../Config";
// import AdvertisementCard from "../Components/AdvertisementCard";

// const HowToMakeVariation = () => {
//   const [variations, setVariations] = useState({});
//   const [sideData, setSideData] = useState([]);
//   const [selectedType, setSelectedType] = useState(null);
//   const [selectedSubheading, setSelectedSubheading] = useState(null);
//   const [contentList, setContentList] = useState([]);
//   const [loadingContent, setLoadingContent] = useState(false);

//   useEffect(() => {
//     fetchVariationNames();
//   }, []);

//   const fetchVariationNames = async () => {
//     try {
//       const res = await axios.get(`${API_BASE_URL}/makevariations/names`);
//       const list = res.data.data || [];
//       const sidebar = res.data.sideData || [];

//       const grouped = {};
//       list.forEach((item) => {
//         const type = item.variationType?.[0] || "Other";
//         if (!grouped[type]) grouped[type] = [];
//         if (item.asanaType) grouped[type].push(item);
//       });

//       setVariations(grouped);
//       setSideData(sidebar);

//       // Auto-select first type and subheading
//       const firstType = Object.keys(grouped)[0];
//       if (firstType) {
//         setSelectedType(firstType);
//         const firstSub = grouped[firstType]?.[0]?.asanaType;
//         if (firstSub) {
//           setSelectedSubheading(firstSub);
//           fetchContentBySubheading(firstSub);
//         }
//       }
//     } catch (error) {
//       console.error("API Fetch Error", error);
//     }
//   };

//   // Fetch all variations for a specific subheading (asanaType)
//   const fetchContentBySubheading = async (subheading) => {
//     setLoadingContent(true);
//     try {
//       const res = await axios.get(
//         `${API_BASE_URL}/makevariations?type=${encodeURIComponent(subheading)}`
//       );
//       const data = res.data?.data || res.data || [];
//       setContentList(Array.isArray(data) ? data : []);
//     } catch (error) {
//       console.error("Content Fetch Error", error);
//       setContentList([]);
//     } finally {
//       setLoadingContent(false);
//     }
//   };

//   const handleSubheadingClick = (subheading) => {
//     setSelectedSubheading(subheading);
//     fetchContentBySubheading(subheading);
//   };

//   return (
//     <div style={{ display: "flex", minHeight: "100vh" }}>
//       {/* Sidebar */}
//       <PageSliderBar
//         title="How to make variation"
//         data={variations}
//         sideData={sideData}
//         selectedSubheading={selectedSubheading}
//         onSubheadingClick={handleSubheadingClick}
//       />

//       {/* Main Content */}
//       <div style={{ flex: 1, padding: "30px 40px", overflowY: "auto" }}>
//         {selectedSubheading && (
//           <h1
//             style={{
//               textAlign: "center",
//               fontWeight: "bold",
//               fontSize: 28,
//               marginBottom: 32,
//             }}
//           >
//             {selectedSubheading}
//           </h1>
//         )}

//         {loadingContent ? (
//           <div style={{ textAlign: "center", padding: 60, fontSize: 18 }}>
//             Loading...
//           </div>
//         ) : contentList.length === 0 ? (
//           <div style={{ textAlign: "center", padding: 60, color: "#aaa" }}>
//             No variations found.
//           </div>
//         ) : (
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
//               gap: 28,
//             }}
//           >
//             {contentList.map((item, index) => (
//               <VariationCard key={item._id} item={item} index={index} />
//             ))}
//           </div>
//         )}
//       </div>

//       <AdvertisementCard />
//     </div>
//   );
// };

// // ── Single Variation Card ──────────────────────────────────────────────
// const VariationCard = ({ item, index }) => {
//   return (
//     <div
//       style={{
//         background: "#fff",
//         borderRadius: 16,
//         boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
//         overflow: "hidden",
//         padding: 24,
//         display: "flex",
//         flexDirection: "column",
//         gap: 12,
//       }}
//     >
//       {/* Number + Name */}
//       <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700, textAlign: "center" }}>
//         {index + 1}. {item.variationName}
//       </h3>

//       {/* Image */}
//       {item.variationImage && (
//         <div style={{ textAlign: "center" }}>
//           <img
//             src={item.variationImage}
//             alt={item.variationName}
//             style={{
//               width: "100%",
//               maxHeight: 240,
//               objectFit: "contain",
//               borderRadius: 12,
//               background: "#f5f5f5",
//             }}
//           />
//         </div>
//       )}

//       {/* Details */}
//       <div style={{ fontSize: 14, lineHeight: 1.7 }}>
//         {item.sanskrit && (
//           <p style={{ margin: "4px 0" }}>
//             <strong>Sanskrit:</strong> {item.sanskrit}
//           </p>
//         )}
//         {item.english && (
//           <p style={{ margin: "4px 0" }}>
//             <strong>English:</strong> {item.english}
//           </p>
//         )}
//         {item.exampleAsana && (
//           <p style={{ margin: "4px 0" }}>
//             <strong>Example Asanas:</strong> {item.exampleAsana}
//           </p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default HowToMakeVariation;
import React, { useEffect, useState } from "react";
import PageSliderBar from "../Components/PageSliderBar/PageSliderBar";
import axios from "axios";
import { API_BASE_URL } from "../Config";
import AdvertisementCard from "../Components/AdvertisementCard";

const HowToMakeVariation = () => {
  const [variations, setVariations] = useState({});
  const [sideData, setSideData] = useState([]);

  useEffect(() => {
    fetchVariationNames();
  }, []);

  const fetchVariationNames = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/makevariations/names`);
      const list = res.data.data || [];

      // Group items by variationType
      const grouped = {};
      list.forEach((item) => {
        const type = item.variationType?.[0] || "Other";
        if (!grouped[type]) grouped[type] = [];
        grouped[type].push(item); // include ALL items
      });

      // ── FIX: sideData must be unique asanaType values (pose names) ──
      // NOT variationType values — PageSliderBar filters by asanaType
      const uniqueAsanaTypes = [];
      list.forEach((item) => {
        if (item.asanaType && !uniqueAsanaTypes.includes(item.asanaType)) {
          uniqueAsanaTypes.push(item.asanaType);
        }
      });

      setVariations(grouped);
      setSideData(uniqueAsanaTypes); // ← ["Namaskar", "Viparita Namaskar", "Manibandha", ...]
    } catch (error) {
      console.error("API Fetch Error", error);
    }
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <PageSliderBar
        title="How to make variation"
        basePath="/how-to-make-variation"
        data={variations}
        sideData={sideData}
      />
      <AdvertisementCard />
    </div>
  );
};

export default HowToMakeVariation;
